import React from "react";
import "../styles/CaesarСipherTopBar.css";
import { useGame } from "../GameContext";
const TopBar: React.FC = () => {
  const { message, setHelpPanelOpen } = useGame();
  return (
      <div className="CaesarСipher-top-bar">
        <a className="CaesarСipher-logo" href="https://kotobot.app/index.html">
          <img
            className="CaesarСipher-logo"
               title ="На главную"
            src="/img/kotobot.svg"
            alt="Kotobot logo"
          />
        </a>
        <div className="CaesarСipher-message-bar">{message}</div>
        <img
          className="CaesarСipher-icon"
          id = "CaesarСipher-help-icon"
          alt="Помощь"
          src="/img/help-fix.svg"
          title="Помощь"
          onClick={() => setHelpPanelOpen(true)}
        />
      </div>
  );
};

export default TopBar;
